import React, { useContext, useState } from "react";
import { Box, Fab, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { UserDataContext } from "../../Contexts/UserDataContext";
import EntityFormControl from "./EntityFormControl";
import { Add, Search } from "@material-ui/icons";
import { columns, defaultBranch, branchDefinition } from "./BranchEntityClass";
import Axios from "axios";
import {
  SelectActiveInputComponent,
  SelectStateInputComponent,
  SelectVendorIdInputComponent,
} from "./InputComponents";
import EntityTableFilter from "./EntityTableFilter";
import EntityTable from "./EntityTable";

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    margin: theme.spacing(0, 0, 4, 0),
  },
  flexRowContainer: {
    display: "flex",
    alignItems: "center",
  },
  filter: {
    width: "160px",
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  tableFilter: {
    flexGrow: 1,
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
}));

const BranchPage = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const { userData } = useContext(UserDataContext);
  const [branchList, setbranchList] = useState([]);
  const [filterExpression, setFilterExpression] = useState("");
  const [filterParameters, setFilterParameters] = useState({
    state: undefined,
  });

  const fetchBranches = async () => {
    const queryString = Object.keys(filterParameters)
      .filter((key) => filterParameters[key])
      .map((key) => `${key}=${filterParameters[key]}`)
      .join("&");

    const request = {
      method: "GET",
      url: `/branches/search?${queryString}`,
      // url: `/users`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };

    try {
      const res = await Axios(request);
      console.log(res.data);
      setbranchList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const createBranch = async (entity, onSuccessCallback, onFailCallback) => {
    const request = {
      method: "POST",
      url: "/branches/add",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: entity,
    };
    try {
      await Axios(request);
      onSuccessCallback();
      fetchBranches();
    } catch (error) {
      console.log(error);
      onFailCallback(error.response.data.message);
    }
  };

  const editBranch = async (entity, onSuccessCallback, onFailCallback) => {
    const request = {
      method: "POST",
      url: "/branches/change",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: entity,
    };
    try {
      await Axios(request);
      onSuccessCallback();
      fetchBranches();
    } catch (error) {
      console.log(error);
      onFailCallback(error.response.data.message);
    }
  };

  return (
    <Box className={clsx(className, classes.flexColContainer)} {...rest}>
      <Box className={clsx(classes.flexColItem, classes.flexRowContainer)}>
        <EntityFormControl
          buttonComponent={(buttonProps) => (
            <Fab
              className={clsx(classes.marginRight)}
              variant="extended"
              color="primary"
              {...buttonProps}
            >
              <Add className={classes.extendedIcon} />
              Create
            </Fab>
          )}
          title="Create Branch"
          columns={columns}
          initialData={defaultBranch}
          entityDefinition={branchDefinition}
          onSubmit={createBranch}
        />
        <SelectStateInputComponent
          className={clsx(classes.filter)}
          name="state"
          variant="outlined"
          label="Status"
          value={filterParameters.state}
          onUpdate={(name, value) =>
            setFilterParameters({ ...filterParameters, [name]: value })
          }
        />
        <Fab
          className={clsx(classes.marginLeft, classes.marginRight)}
          onClick={fetchBranches}
          variant="extended"
        >
          <Search className={classes.extendedIcon} />
          Search
        </Fab>
        <EntityTableFilter
          className={clsx(classes.tableFilter)}
          expression={filterExpression}
          setExpression={setFilterExpression}
        />
      </Box>

      <EntityTable
        className={clsx(classes.flexColItem, classes.center)}
        entityDefinition={branchDefinition}
        tableColumns={columns}
        rows={branchList}
        formTitle="Edit Branch"
        onEdit={editBranch}
        filterExpression={filterExpression}
      />
    </Box>
  );
};

export default BranchPage;
